export enum Roles {
    ADMIN = 'Admin',
    Commercials = 'Commercials',
    CustomerSupport = 'CustomerSupport',
    Customs = 'Customs',
    ECommerce = 'ECommerce',
    ExportClassification = 'ExportClassification',
    FactoryDataManager = 'FactoryDataManager',
    KnowledgeManager = 'KnowledgeManager',
    Logistics = 'Logistics',
    ProductLifecycleManager = 'ProductLifecycleManager'
}
